import Vue from "vue";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap-vue/dist/bootstrap-vue.min.css'

Vue.use(BootstrapVue, BootstrapVueIcons);
